<ng-container
    *ngIf="{ states: states$ | async, hasScaledPlans: hasScaledPlans$ | async, supportedUnits: supportedUnits$ | async } as settings">
    <div *ngIf="settings.states" class="panel" [ngClass]="{ 'over-layer': viewSettings.isOverLayer, 'over-layer-collapse': !isExpanded }">
        <ng-container *ngIf="measurementCategories$ | async as measurementCategories">
            <div class="panel-heading estimate-measurement-settings">
                <app-estimate-measurements-settings
                    [states]="settings.states"
                    [viewSettings]="viewSettings"
                    [isExpanded]="isExpanded"
                    [hasMeasurements]="measurementCategories.length > 0"
                    [measurementsDrawingStatus]="(measurementsDrawingStatus$ | async)!"
                    [hasPlans]="hasPlans() ?? false"
                    (addCategoryChanges)="onAddCategory()"
                    (addMeasurementChanges)="onAddMeasurement('')"
                    (printChanges)="onPrintMeasurements($event)"
                    (emailChanges)="onEmailMeasurements($event)"
                    (toggleAllTakeOffsChanges)="toggleAllTakeOffs($event)"
                    (toggleMeasurementsChanges)="toggleMeasurements()"
                    (launchTakeoffsEvent)="launchTakeoffs()"
                    (deleteAllMeasurementsChanges)="deleteAllMeasurements()">
                </app-estimate-measurements-settings>
            </div>

            <!-- Search Component -->
            <div class="panel-heading estimate-measurement-search-heading" *ngIf="isExpanded">
                <app-estimate-measurement-search class="estimate-measurement-search" (filterChanges)="onSearchFilterChanged($event)">
                </app-estimate-measurement-search>
            </div>

            <!-- Category Drag Drop Container -->
            <div
                *ngIf="isExpanded"
                id="measurement-list"
                class="measurement-list"
                [ngClass]="{
                    'panel-body': measurementCategories.length,
                    'measurement-list-empty': !measurementCategories.length,
                }"
                [@slideInTop]="slideInTopParams"
                cdkDropList
                [cdkDropListSortingDisabled]="true"
                [cdkDropListData]="measurementCategories"
                (cdkDropListDropped)="onDropMeasurementCategory($event)">
                <!-- Category Drag Drop Item -->
                <div
                    [class]="dragItemTypes.Category + '-container'"
                    *ngFor="let measurementCategory of measurementCategories"
                    cdkDrag
                    cdkDragBoundary=".measurement-list"
                    cdkDragLockAxis="y"
                    [attr.data-index]="
                        (measurementCategory.measurements
                            ? dragItemTypes.Category + '_' + measurementCategory.id
                            : dragItemTypes.Measurement + '_null') +
                        '_' +
                        measurementCategory.order
                    "
                    [cdkDragDisabled]="isDragDisabled"
                    (cdkDragMoved)="onDragCategoryMoved($event, !!measurementCategory.measurements)">
                    <ng-container *ngIf="measurementCategory.measurements; else measurementWithoutCategory">
                        <app-estimate-measurement-category
                            [states]="settings.states"
                            [measurementCategory]="measurementCategory"
                            (updateCategoryChanges)="onUpdateCategory($event)"
                            (deleteCategoryChanges)="onDeleteCategory($event)"
                            (toggleCategoryChanges)="onToggleCategory($event)"
                            (toggleCategoryDragging)="onToggleDragging($event)">
                            <section class="estimate-measurement-container mt-2">
                                <!-- Estimate Measurement Items -->
                                <ng-container *ngIf="supportedUnits || settings.supportedUnits">
                                    <!-- Measurement Drag Drop Container -->
                                    <div
                                        *ngIf="measurementCategory.measurements"
                                        cdkDropList
                                        [cdkDropListSortingDisabled]="true"
                                        [cdkDropListData]="measurementCategory.measurements"
                                        (cdkDropListDropped)="onDropMeasurement($event)">
                                        <!-- Measurement Drag Drop Item -->
                                        <div
                                            [class]="dragItemTypes.Measurement + '-container'"
                                            *ngFor="let measurement of measurementCategory.measurements"
                                            cdkDrag
                                            cdkDragBoundary=".measurement-list"
                                            cdkDragLockAxis="y"
                                            [attr.data-index]="
                                                dragItemTypes.Measurement + '_' + measurement.parentId + '_' + measurement.order
                                            "
                                            [cdkDragDisabled]="isDragDisabled"
                                            (cdkDragMoved)="onDragMeasurementMoved($event)">
                                            <app-estimate-measurement
                                                [estimateMeasurement]="measurement"
                                                [supportedUnits]="supportedUnits || settings.supportedUnits"
                                                [hasPlans]="!!settings.hasScaledPlans"
                                                [states]="settings.states"
                                                [viewSettings]="viewSettings"
                                                [parentOrder]="measurementCategory.order"
                                                (takeOffsChanges)="onTakeOffs($event)"
                                                (updateMeasurementChanges)="onMeasurementUpdated($event)"
                                                (calculateMeasurementChanges)="onCalculate($event)"
                                                (toggleMeasurementChanges)="toggleTakeOffsForMeasurement($event)"
                                                (deleteMeasurementChanges)="onDelete($event)"
                                                (toggleMeasurementDragging)="onToggleDragging($event)">
                                            </app-estimate-measurement>
                                        </div>
                                        <!--/ Measurement Drag Drop Item -->
                                    </div>
                                    <!--/ Measurement Drag Drop Container -->
                                </ng-container>

                                <!-- Add Estimate Measurement -->
                                <div class="mt-2" *ngIf="!settings.states.isEstimateDisabled && !settings.states.isEstimateReadonly">
                                    <button
                                        type="button"
                                        id="btn-add-measurement"
                                        class="btn-bx-secondary-stroked"
                                        (click)="onAddMeasurement(measurementCategory.id ?? '')">
                                        <i class="fa-solid fa-plus text-bold"></i> Add measurement
                                    </button>
                                </div>
                            </section>
                        </app-estimate-measurement-category>
                    </ng-container>

                    <ng-template #measurementWithoutCategory>
                        <app-estimate-measurement
                            [estimateMeasurement]="measurementCategory"
                            [supportedUnits]="supportedUnits || settings.supportedUnits"
                            [hasPlans]="!!settings.hasScaledPlans"
                            [states]="settings.states"
                            [viewSettings]="viewSettings"
                            (takeOffsChanges)="onTakeOffs($event)"
                            (updateMeasurementChanges)="onMeasurementUpdated($event)"
                            (calculateMeasurementChanges)="onCalculate($event)"
                            (toggleMeasurementChanges)="toggleTakeOffsForMeasurement($event)"
                            (deleteMeasurementChanges)="onDelete($event)"
                            (toggleMeasurementDragging)="onToggleDragging($event)">
                        </app-estimate-measurement>
                    </ng-template>
                </div>
                <!--/ Category Drag Drop Item -->

                <ng-container *ngIf="!measurementCategories.length">
                    <div class="empty-state">
                        <section class="empty-state__header mb-3" [ngClass]="{ 'empty-state__header--light': viewSettings.isOverLayer }">
                            No measurements added yet
                        </section>
                        @if (!viewSettings.isOverLayer) {
                            <section class="empty-state__desc">
                                <p class="mb-3">
                                    Upload a plan, go to an item in your <strong>Estimate Costings</strong> and use the takeoff button
                                    <i class="ti-ruler-alt-2"></i> to add measurements.
                                </p>
                                <p>Any takeoffs created in Estimate costings will appear here.</p>
                            </section>
                            <div class="empty-state__img"></div>
                        }
                    </div>
                </ng-container>
            </div>
            <!--/ Category Drag Drop Container -->
        </ng-container>
    </div>
</ng-container>
